<template>
  <p aria-live="polite" aria-atomic="true">Reservations last updated:
    <span v-if="loading" aria-busy="true"><v-progress-circular indeterminate size=15 width=2 color="primary" aria-hidden="true"/></span>
    <span v-else>{{lastUpdated}}</span>
  </p>
</template>
<script>
  import axios from 'axios'
  import moment from 'moment'
  import config from '../config'

  export default {
    data: () => ({
      loading: false,
      lastUpdated: null
    }),
    mounted: function() {
      this.setTimestamp()
      setInterval(function() {
        this.setTimestamp()
      }.bind(this), 5*60*1000)
    },
    methods: {
      getLastUpdate: function(retries=0) {
        return axios.get(config.s3TimestampUrl).catch(err => {
          if(retries > 0)
            return this.getLastUpdate(retries - 1)
          else
            return Promise.reject(err)
        })
      },
      setTimestamp: function() {
        let {status, value, pullTime} = this.$store.state.s3Timestamp
        let isFresh = moment().subtract(config.minutesToRefreshS3Timestamp, 'm').isBefore(moment(pullTime))
        if(status == 'success' && isFresh)
          this.lastUpdated = value
        else {
          this.loading = true
          return this.getLastUpdate(3).then(response => {
            this.lastUpdated = moment(response.data).format('LLL')
            this.$store.commit('setS3Timestamp', { status: 'success', value: this.lastUpdated })
          }).catch(() => {
            this.lastUpdated = 'Error reading time of last update."'
            this.$store.commit('setS3Timestamp', { staus: 'error', value: null })
          }).finally(() => {
            this.loading = false
          })
        }
      }
    }
  }
</script>